import { getProps } from '../../../props';

export default (content) => () => {

  const { onSelect, onClose } = getProps();

  onSelect(content);
  onClose();

}